import React, { useEffect, useRef, useState } from 'react';
import DemoDownloadButton from './DemoDownloadButton';
import './MatchDemosButton.css';

/**
 * Demo-download button for a match. When `mapDemos` contains more than one
 * entry, renders a dropdown listing one item per map. When zero or one entry,
 * falls back to the regular single-demo button so BO1 matches look unchanged.
 */
const MatchDemosButton = ({ mapDemos, fallbackUrl, hasDemo, size = 'medium' }) => {
  const list = Array.isArray(mapDemos) ? mapDemos : [];
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  if (list.length <= 1) {
    const single = list[0];
    const url = single?.download_url || fallbackUrl;
    return (
      <DemoDownloadButton
        demoUrl={url}
        hasDemo={Boolean(url) || hasDemo}
        size={size}
      />
    );
  }

  return (
    <div className="match-demos-wrapper" ref={wrapperRef}>
      <button
        className={`demo-button demo-button-${size}`}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        title="Ladda ner demos"
      >
        <span className="demo-icon">📥</span>
        <span className="demo-text">Demos ({list.length})</span>
        <span className="match-demos-caret">▾</span>
      </button>
      {open && (
        <div className="match-demos-menu" onClick={(e) => e.stopPropagation()}>
          {list.map((d) => (
            <a
              key={d.map_number}
              href={d.download_url}
              target="_blank"
              rel="noopener noreferrer"
              className="match-demos-item"
              onClick={() => setOpen(false)}
            >
              <span className="match-demos-map">Karta {d.map_number + 1}</span>
              <span className="match-demos-name">{d.mapname || d.demo_filename || '—'}</span>
              <span className="match-demos-icon">📥</span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default MatchDemosButton;
